export default "__VITE_ASSET__AkY2118G__"